import $ from 'jquery';
import ApexCharts from 'apexcharts';

$(function () {
    const $container = $('#inflation-calculator-app');
    if (!$container.length) return;

    let currency = $container.data('currency') || 'UAH';
    let symbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : currency === 'PLN' ? 'zł' : '₴';
    let chartInstance = null;

    const textMoreCurrencies = $container.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $container.data('text-more-short') || 'Ще';

    const $initBtn = $('#inflation-currency-tabs button.active');
    if ($initBtn.length) {
        currency = $initBtn.data('currency-code') || currency;
        symbol = $initBtn.data('symbol') || symbol;
    }

    const culture = $container.data('culture') || 'uk-UA';
    const localeMap = { 'uk': 'uk-UA', 'pl': 'pl-PL', 'de': 'de-DE', 'es': 'es-ES', 'it': 'it-IT', 'en': 'en-US' };
    const dateLocale = localeMap[culture] || 'en-US';

    const unitYears = $container.data('unit-years') || 'р.';
    const seriesAlt = $container.data('series-alt') || 'Альтернатива (ОВДП / Інвестиції)';
    const seriesNominal = $container.data('series-nominal') || 'Номінальна готівка';
    const seriesReal = $container.data('series-real') || 'Реальна купівельна спроможність';

    const $amountRange = $('#inf-amount-range');
    const $amountDisplay = $('#inf-amount-display');

    const $rateRange = $('#inf-rate-range');
    const $rateDisplay = $('#inf-rate-display');

    const $yearsRange = $('#inf-years-range');
    const $yearsDisplay = $('#inf-years-display');

    const $altRange = $('#inf-alt-range');
    const $altDisplay = $('#inf-alt-display');

    function formatMoney(num) {
        return Math.round(num).toLocaleString(dateLocale) + ' ' + symbol;
    }

    function calculate() {
        const cashAmount = parseFloat($amountRange.val()) || 100000;
        const inflationRate = (parseFloat($rateRange.val()) || 8.5) / 100;
        const years = parseInt($yearsRange.val(), 10) || 5;
        const alternativeRate = (parseFloat($altRange.val()) || 14.5) / 100;

        $amountDisplay.text(formatMoney(cashAmount));
        $rateDisplay.text((inflationRate * 100).toFixed(1) + '%');
        $yearsDisplay.text(years + ' ' + unitYears);
        $altDisplay.text((alternativeRate * 100).toFixed(1) + '%');

        const labels = ['0 ' + unitYears];
        const nominalData = [Math.round(cashAmount)];
        const realPurchasingData = [Math.round(cashAmount)];
        const alternativeData = [Math.round(cashAmount)];

        for (let y = 1; y <= years; y++) {
            labels.push(y + ' ' + unitYears);
            nominalData.push(Math.round(cashAmount));

            // Real purchasing power after y years
            const realVal = cashAmount / Math.pow(1 + inflationRate, y);
            realPurchasingData.push(Math.round(realVal));

            // Alternative investment value
            const altVal = cashAmount * Math.pow(1 + alternativeRate, y);
            alternativeData.push(Math.round(altVal));
        }

        const finalRealVal = realPurchasingData[realPurchasingData.length - 1];
        const lostPurchasingVal = cashAmount - finalRealVal;
        const lostPct = ((lostPurchasingVal / cashAmount) * 100).toFixed(1);

        const finalAltVal = alternativeData[alternativeData.length - 1];
        const altGain = finalAltVal - cashAmount;

        $('#inf-kpi-real').text(formatMoney(finalRealVal));
        $('#inf-kpi-lost').text('-' + formatMoney(lostPurchasingVal) + ' (-' + lostPct + '%)');
        $('#inf-kpi-alt').text('+' + formatMoney(altGain));

        renderChart(labels, nominalData, realPurchasingData, alternativeData);
    }

    function renderChart(labels, nominalData, realData, altData) {
        const isDark = $('body').hasClass('dark') || $('body').attr('data-layout-mode') === 'dark';

        const options = {
            series: [
                { name: seriesAlt, data: altData },
                { name: seriesNominal, data: nominalData },
                { name: seriesReal, data: realData }
            ],
            chart: {
                type: 'line',
                height: 270,
                toolbar: { show: false },
                animations: { enabled: true, speed: 400 }
            },
            colors: ['#34c38f', '#74788d', '#f46a6a'],
            stroke: {
                curve: 'smooth',
                width: [3, 2, 3],
                dashArray: [0, 4, 0]
            },
            dataLabels: { enabled: false },
            xaxis: {
                categories: labels,
                labels: { style: { colors: isDark ? '#a6b0cf' : '#74788d' } }
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M ' + symbol;
                        if (val >= 1000) return Math.round(val / 1000) + 'K ' + symbol;
                        return Math.round(val) + ' ' + symbol;
                    },
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' }
                }
            },
            tooltip: {
                theme: isDark ? 'dark' : 'light',
                y: {
                    formatter: function (val) {
                        return formatMoney(val);
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                labels: { colors: isDark ? '#a6b0cf' : '#74788d' }
            },
            grid: {
                borderColor: isDark ? '#32394e' : '#f1f1f1'
            }
        };

        const chartEl = document.querySelector('#inflation-loss-chart');
        if (!chartEl) return;

        if (chartInstance) {
            chartInstance.updateOptions(options);
        } else {
            chartInstance = new ApexCharts(chartEl, options);
            chartInstance.render();
        }
    }

    // Event Listeners
    $amountRange.on('input', calculate);
    $rateRange.on('input', calculate);
    $yearsRange.on('input', calculate);
    $altRange.on('input', calculate);

    // Amount Chips
    $(document).on('click', '.chip-amount', function () {
        $('.chip-amount').removeClass('active');
        $(this).addClass('active');
        const val = parseFloat($(this).data('value'));
        if (!isNaN(val)) {
            $amountRange.val(val);
            calculate();
        }
    });

    // Currency Switcher
    function setInflationCurrency(btn, isDropdown) {
        currency = $(btn).data('currency-code');
        symbol = $(btn).data('symbol') || '$';

        if (isDropdown) {
            $('#inflation-currency-tabs > button[data-currency-code]').removeClass('active');
            $('.inflation-currency-dropdown-item').removeClass('active');
            $(btn).addClass('active');
            $('.inflation-more-currencies-btn').addClass('active');
            $('#inflation-active-custom-currency').text(`${symbol} ${currency}`);
        } else {
            $('#inflation-currency-tabs button').removeClass('active');
            $(btn).addClass('active');
            $('.inflation-more-currencies-btn').removeClass('active');
            $('.inflation-currency-dropdown-item').removeClass('active');
            $('#inflation-active-custom-currency').html(`
                <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
                <span class="d-sm-none">${textMoreShort}</span>
            `);
        }

        const defAmount = parseFloat($(btn).data('default-amount')) || 100000;
        const defInflation = parseFloat($(btn).data('default-inflation')) || 8.5;
        const defAlt = parseFloat($(btn).data('default-alternative')) || 14.5;

        $amountRange.val(defAmount);
        $rateRange.val(defInflation);
        $altRange.val(defAlt);

        if (currency === 'USD' || currency === 'EUR' || currency === 'GBP' || currency === 'CHF' || currency === 'CAD') {
            $amountRange.attr({ max: 200000, step: 1000 });
        } else if (currency === 'PLN') {
            $amountRange.attr({ max: 800000, step: 5000 });
        } else {
            $amountRange.attr({ max: 3000000, step: 10000 });
        }

        const chips = $(btn).data('chips');
        if (Array.isArray(chips)) {
            const $chipsContainer = $('#inf-amount-chips').empty();
            chips.forEach(c => {
                const isAct = c === defAmount ? 'active' : '';
                const displayChip = c >= 1000000 ? (c / 1000000) + 'M' : (c / 1000) + 'K';
                $chipsContainer.append(`<button type="button" class="btn btn-xs btn-soft-secondary chip-amount ${isAct}" data-value="${c}">${displayChip}</button>`);
            });
        }

        calculate();
    }

    $('#inflation-currency-tabs > button[data-currency-code]').on('click', function () {
        setInflationCurrency(this, false);
    });

    $(document).on('click', '.inflation-currency-dropdown-item', function (e) {
        e.preventDefault();
        setInflationCurrency(this, true);
    });

    calculate();
});

